import {Table, Tag} from "antd";
import className from "classnames/bind";
import {UrlLink, StatusTag, fmt} from "./TechShared";
import style from "../style/Technical.module.scss";

const cn = className.bind(style);

/**
 * Liên kết nội bộ: phân bố độ sâu, top trang được trỏ tới nhiều nhất (link authority) và
 * cơ hội liên kết (#29) — trang mồ côi / ít link nội bộ nên được liên kết thêm.
 */
function TechInternalLinks({internal}) {

	const {top_linked = [], opportunities = [], depth_dist = {}} = internal || {};

	const depths = Object.keys(depth_dist).map(Number).sort((a, b) => a - b);
	const maxDepthCount = Math.max(1, ...depths.map((d) => depth_dist[d]));

	const topColumns = [
		{title: 'Trang', dataIndex: 'url', ellipsis: true, render: (url, r) => <UrlLink url={url} text={r.title || url} />},
		{title: 'Link nội bộ trỏ tới', dataIndex: 'inlinks', width: 160, align: 'right', render: (v) => fmt(v)},
		// Cột phụ — ẩn dưới 768px
		{title: 'Trạng thái', dataIndex: 'status', width: 110, align: 'center', responsive: ['md'], render: (s) => <StatusTag status={s} />},
	];

	const oppColumns = [
		{
			title: 'Trang', dataIndex: 'url', ellipsis: true,
			render: (url, r) => (
				<span>
					{r.orphan && <Tag color="red" style={{marginRight: 6}}>Mồ côi</Tag>}
					<UrlLink url={url} text={r.title || url} />
				</span>
			),
		},
		{title: 'Số link nội bộ', dataIndex: 'inlinks', width: 140, align: 'right'},
	];

	return (
		<div className={cn('tab')}>
			<h4 className={cn('sectionTitle')}>Phân bố độ sâu (số click từ trang gốc)</h4>
			<div className={cn('depthList')}>
				{depths.length === 0 && <div className={cn('muted')}>Không có dữ liệu.</div>}
				{depths.map((d) => (
					<div className={cn('depthRow')} key={d}>
						<span className={cn('depthLabel')}>{d === 0 ? 'Trang gốc' : `Độ sâu ${d}`}</span>
						<div className={cn('depthBarTrack')}>
							<div className={cn('depthBarFill')} style={{width: `${(depth_dist[d] / maxDepthCount) * 100}%`}} />
						</div>
						<span className={cn('depthCount')}>{fmt(depth_dist[d])}</span>
					</div>
				))}
			</div>

			<h4 className={cn('sectionTitle')}>Top trang được liên kết nội bộ nhiều nhất</h4>
			<Table size="small" rowKey={(r) => r.url} columns={topColumns} dataSource={top_linked}
				scroll={{x: 'max-content'}} pagination={{pageSize: 10, hideOnSinglePage: true}} />

			<h4 className={cn('sectionTitle')}>
				Cơ hội liên kết — trang mồ côi / ít link nội bộ ({opportunities.length})
			</h4>
			<p className={cn('muted')}>Các trang này nên được liên kết thêm từ nội dung liên quan để tăng khả năng khám phá & xếp hạng.</p>
			<Table size="small" rowKey={(r) => r.url} columns={oppColumns} dataSource={opportunities}
				scroll={{x: 'max-content'}} pagination={{pageSize: 10, hideOnSinglePage: true}} />
		</div>
	);
}

export default TechInternalLinks;
